import { FC } from 'react';

type Props = {
	className?: string;
};

const Calendar03Icon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M14.799 2V3.59997M5.19922 2V3.59997'
				stroke='inherit'
				strokeWidth='1.19998'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M9.99321 10.8003H10.0004M9.99321 14.0002H10.0004M13.1895 10.8003H13.1967M6.79688 10.8003H6.80405M6.79688 14.0002H6.80405'
				stroke='inherit'
				strokeWidth='1.75'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M3.19922 6.7998H16.7989'
				stroke='inherit'
				strokeWidth='1.19998'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M2.39844 10.1947C2.39844 6.70897 2.39844 4.96607 3.40011 3.88318C4.40179 2.80029 6.01396 2.80029 9.2383 2.80029H10.7583C13.9826 2.80029 15.5948 2.80029 16.5965 3.88318C17.5981 4.96607 17.5981 6.70897 17.5981 10.1947V10.6056C17.5981 14.0913 17.5981 15.8342 16.5965 16.9171C15.5948 18 13.9826 18 10.7583 18H9.2383C6.01396 18 4.40179 18 3.40011 16.9171C2.39844 15.8342 2.39844 14.0913 2.39844 10.6056V10.1947Z'
				stroke='inherit'
				strokeWidth='1.19998'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M2.79688 6.7998H17.1966'
				stroke='inherit'
				strokeWidth='1.19998'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default Calendar03Icon;
